module.exports = __webpack_public_path__ + "static/media/r3-splash.15a11ebe.jpg";